<template>
    <v-app>
        <Navbar />
        <v-main>
            <router-view />
        </v-main>
        <Footer />
        <PromptUpdate />
        <CookieBanner />
    </v-app>
</template>

<script setup lang="ts">
    import Navbar from './views/Navbar.vue';
    import Footer from './views/Footer.vue';
    import PromptUpdate from '@/components/shared/PromptUpdate.vue';
    import CookieBanner from '@/components/shared/CookieBanner.vue';
    import { useAppStore } from './store/app';
    import { useLocale } from './composables/useLocale';
    import { useGoogleAnalytics } from '@/composables/useGoogleAnalytics';
    import { onMounted, watch } from 'vue';
    import { useRoute } from 'vue-router';

    const appStore = useAppStore();
    const { setLocale, getLocale } = useLocale();
    const { initialize, trackPageView } = useGoogleAnalytics();
    const route = useRoute();

    // get browser locale
    // const browserLocale = navigator.language.split('-')[0];
    // if (!appStore.hasUserChangedLocale) {
    //     setLocale(browserLocale);
    // } else {
    //     setLocale(getLocale());
    // }
    setLocale('pt');

    appStore.fillStore();

    // Initialize Google Analytics on mount
    onMounted(() => {
        initialize();
    });

    // Track page views on route changes
    watch(
        () => route.path,
        (newPath) => {
            trackPageView(newPath);
        }
    );
</script>
